import en from "./locales/en.json";
import sv from "./locales/sv.json";
import no from "./locales/no.json";
import fr from "./locales/fr.json";
export default () => ({
  legacy: false,
  locale: "en",
  messages: {
    en,
    sv,
    no,
    fr
  }
});
